<template>
  <main class="security">
    <Header />
    <section class="template-header d-flex justify-center align-center text-center">
      <div class="shadow"></div>
      <div class="item">
        <h1
          class="font-weight-regular text-uppercase px-4"
        >{{ $vuetify.lang.t('$vuetify.security.template-header.title') }}</h1>
      </div>
    </section>
    <section class="template pt-6 pb">
      <v-container>
        <v-row :class="{hide: this.$vuetify.lang.current !== 'ru'}">
          <v-col class="text-center">
            <h1>Карточка предприятия</h1>
          </v-col>
        </v-row>
        <v-row class="pt-6" :class="{hide: this.$vuetify.lang.current !== 'ru'}">
          <v-col>
            <v-simple-table dense dark>
              <template>
                <tbody>
                  <tr v-for="item in desserts" :key="item.name">
                    <td>{{ item.name }}</td>
                    <td>{{ item.calories }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row class="pt">
          <v-col class="text-center">
            <h1>{{ $vuetify.lang.t('$vuetify.security.template.title') }}</h1>
          </v-col>
        </v-row>
        <v-row class="pt-6">
          <v-col :class="{hide: this.$vuetify.lang.current !== 'ru'}">
            <h3 class="mb-3 mark">Реквизиты счета в рублях</h3>
            <h3>ООО "ТРЕВЕЛ ПРАКТИКА"</h3>
            <span>Номер счёта: 40702810302590002570</span>
            <br />
            <span>Валюта: Рубли</span>
            <br />
            <span>ИНН: 7702432406</span>
            <br />
            <span>Банк: АО «АЛЬФА-БАНК»</span>
            <br />
            <span>КПП: 770201001</span>
            <br />
            <span>БИК: 044525593</span>
            <br />
            <span>Кор. счёт: 30101810200000000593</span>
          </v-col>
          <v-col>
            <h3 class="mb-3 mark">{{ $vuetify.lang.t('$vuetify.security.template.requisite') }}</h3>
            <br />
            <span>Beneficiary acc. No: 40702978602590000350 (EUR)</span>
            <br />
            <span>Beneficiary acc. No: 40702840902590000434 (USD)</span>
            <br />
            <br />
            <span>Beneficiary's name: LLC 'TRAWELL PRAKTIKA'</span>
            <br />
            <span>Beneficiary's address: BULVAR. TSVETNOI, D. 30, C. 1, KV./ MOSCOW, RUSSIA</span>
            <br />
            <span>SWIFT: ALFARUMM</span>
            <br />
            <span>Beneficiary's bank : AO «ALFA-BANK»</span>
            <br />
            <span>Beneficiary's bank address: 27 Kalanchevskaya str., Moscow, 107078</span>
          </v-col>
        </v-row>
        <v-row class="pt-6" :class="{hide: this.$vuetify.lang.current !== 'ru'}">
          <v-col>
            <p
              class="mb-0"
            >Также, для Вашего удобства, мы используем сервис ЯндексДеньги. Если вам удобен этот вариант, напишите нам на account@trawellpraktika.com. Обращаем Ваше внимание, что сервис ЯндексДеньги берет комиссию 6%, которую необходимо прибавлять к стоимости приобретенных туристических услуг в нашей компании.</p>
          </v-col>
        </v-row>
        <v-row class="pt-6" :class="{hide: this.$vuetify.lang.current !== 'ru'}">
          <v-col>
            <v-btn color="#fff" outlined large @click="contract = true">Заполнить договор</v-btn>
          </v-col>
        </v-row>
        <v-row class="pt-6" :class="{hide: this.$vuetify.lang.current !== 'ru'}">
          <v-col>
            <h1>Образцы договора</h1>
          </v-col>
        </v-row>
        <v-row :class="{hide: this.$vuetify.lang.current !== 'ru'}">
          <v-col>
            <a href="https://trawellpraktika.com/img/privacy.pdf" target="blank">Для физических лиц</a>
          </v-col>
        </v-row>
        <v-row :class="{hide: this.$vuetify.lang.current !== 'ru'}">
          <v-col>
            <a
              href="https://trawellpraktika.com/img/privacy2.pdf"
              target="blank"
            >Для юридических лиц</a>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <Contract v-model="contract" />
    <Footer />
  </main>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Contract from "../components/modals/Contract.vue";
export default {
  components: {
    Header,
    Footer,
    Contract
  },
  data() {
    return {
      contract: false,
      desserts: [
        {
          name: "Организационно-правовая форма",
          calories: "Общество с ограниченной ответственностью"
        },
        {
          name: "Полное наименование юр. лица",
          calories: "Общество с ограниченной ответственностью «Тревел Практика»"
        },
        {
          name: "Сокращённое наименование юр. лица",
          calories: "ООО «Тревел Практика»"
        },
        {
          name: "ИНН",
          calories: "7702432406"
        },
        {
          name: "КПП",
          calories: "770201001"
        },
        {
          name: "Юридический адрес",
          calories:
            "127051, г. Москва, Цветной б-р, д. 30, стр. 1, пом. 7, ком. 16а, оф. 3е"
        },
        {
          name: "ОГРН",
          calories: "1187746525636"
        },
        {
          name: "Расчетный счет",
          calories: "40702810302590002570"
        },
        {
          name: "Наименование банка",
          calories: 'АО "АЛЬФА-БАНК"'
        },
        {
          name: "ИНН банка",
          calories: "7728168971"
        },
        {
          name: "ОГРН банка",
          calories: "1027700067328"
        },
        {
          name: "БИК",
          calories: "044525593"
        },
        {
          name: "Корр. счет",
          calories: "30101810200000000593 в ГУ БАНКА РОССИИ ПО ЦФО"
        },
        {
          name: "ОКВЭД",
          calories: "79.11"
        },
        {
          name: "ОКПО",
          calories: "28715485"
        },
        {
          name: "Генеральный директор",
          calories: "Кошевой Максим Викторович"
        },
        {
          name: "Главный бухгалтер",
          calories: "Кошевой Максим Викторович"
        },
        {
          name: "Телефон",
          calories: "88005501433, +7(929)6883835"
        }
      ]
    };
  }
};
</script>

<style lang="scss">
#app {
  .security {
    height: 100%;
    .template-header {
      background: url("../assets/background.jpg") center center / cover;
      .shadow {
        opacity: 1;
      }
    }
    .template {
      h3 {
        &.mark {
          display: inline-block;
          border-bottom: 1px solid #ff355a;
        }
      }
      .theme--dark.v-data-table
        tbody
        tr:not(:last-child)
        td:not(.v-data-table__mobile-row) {
        border-bottom: 1px solid rgba(255, 255, 255, 0.8);
      }
      .hide {
        display: none !important;
      }
    }
  }
}
</style>